/**
 * Asynchronously loads the component for ShipppingDelivery
 */

import { lazyLoad } from "utils/loadable";

export const ShipppingDelivery = lazyLoad(
  () => import("./index"),
  (module) => module.ShipppingDelivery
);
